// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__xMEDU","previous":"Pagination_previous__l2WkU","next":"Pagination_next__m5omT","disabled":"Pagination_disabled__WPSLT"};